export default {"src":"/_next/static/media/reverb-icon.d6ae821c.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};